import React from "react";
import "./Exp.css";
import { experience } from "../../portfolio";
import Header from "../Header/Header";

function Exp() {
  return (
    <div>
      <Header title="Experience" />
      <section className="main">
        <div className="row">
          {experience.experience_data.map((item) => {
            return (
              <>
                <div
                  className="col-lg-4 col-md-12 col-sm-12"
                  style={{ margin: "0 auto" }}
                >
                  <div className="card-exp">
                    <div className="flip-card">
                      <div className="flip-card__container">
                        <div className="card-front">
                          <div
                            style={{ background: `${item.color}` }}
                            className="card-front__tp card-front__tp--city text-center"
                          >
                            <h3 className="card-front__heading">{item.name}</h3>
                            <h6>{item.title}</h6>
                            <p>{item.date}</p>
                          </div>

                          <div className="card-front__bt">
                            <p className="card-front__text-view card-front__text-view--city">
                              View me
                            </p>
                          </div>
                        </div>
                        <div className="card-back">
                          <img
                            className="video__container"
                            src={item.imgsrc}
                            alt=""
                          />
                        </div>
                      </div>
                    </div>

                    <div className="inside-page">
                      <div className="inside-page__container">
                        <h3 style={{ color: "#52057b" }}>{item.name}</h3>

                        <ol style={{ overflow: "scroll" }}>
                          {item.content.map((val, idx) => {
                            return <li className="d_color">{val}</li>;
                          })}
                        </ol>

                        <a
                          href={item.detail}
                          className="inside-page__btn inside-page__btn--city"
                        >
                          View details
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </div>
      </section>
    </div>
  );
}

export default Exp;
